<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 40.625rem;
    margin: 0rem auto;
    padding: 1.25rem 1.875rem;
    background-color: #fff;
    border-radius: 0.125rem;
    box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
    max-height: 40rem;
    overflow: overlay;
  }

  .modal-body {
    margin: 1.25rem 0;
    width: 100%;
    overflow: auto;
  }
  @media (max-width: 576px) {
  .modal-container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    height: 80%;
    width: 80%;
  }
  .modal-header {
    padding: 0;
  }
}

</style>

<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header" />
                    </div>

                    <div class="modal-body">
                        <slot name="body" />
                    </div>

                    <div class="modal-buttons">
                        <slot name="buttons" />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
};
</script>
